function Georgia({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1226)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
  <path d="M31.8646 13.9131H18.0871H18.087V0.135438C17.4038 0.0465 16.7073 0 16 0C15.2927 0 14.5962 0.0465 13.9131 0.135438V13.9129V13.913H0.135438C0.0465 14.5962 0 15.2927 0 16C0 16.7074 0.0465 17.4038 0.135438 18.0869H13.9129H13.913V31.8646C14.5962 31.9535 15.2927 32 16 32C16.7073 32 17.4038 31.9536 18.0869 31.8646V18.0871V18.087H31.8646C31.9535 17.4038 32 16.7074 32 16C32 15.2927 31.9535 14.5962 31.8646 13.9131Z" fill="#D80027"/>
  <path d="M9.73912 7.65243V5.56543H7.65219V7.65243H5.56519V9.73937H7.65219V11.8263H9.73912V9.73937H11.8261V7.65243H9.73912Z" fill="#D80027"/>
  <path d="M24.3478 7.65243V5.56543H22.2609V7.65243H20.174V9.73937H22.2609V11.8263H24.3478V9.73937H26.4348V7.65243H24.3478Z" fill="#D80027"/>
  <path d="M9.73912 22.2608V20.1738H7.65219V22.2608H5.56519V24.3477H7.65219V26.4347H9.73912V24.3477H11.8261V22.2608H9.73912Z" fill="#D80027"/>
  <path d="M24.3478 22.2608V20.1738H22.2609V22.2608H20.174V24.3477H22.2609V26.4347H24.3478V24.3477H26.4348V22.2608H24.3478Z" fill="#D80027"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Georgia;
